define('casino/lobby',['jquery','all/dialog', 'casino/casino', 'casino/winners', 'casino/activity-feed', 'casino/start', 'casino/allgames', 'casino/mycasino', 'casino/jackpots', 'casino/tournaments', 'casino/billboard'], function ($, dialog, casino, casinoWinners, activity, casinoStart, allgames, mycasino, jackpots, tournaments, billboard) {

	'use strict';

	var lobby = {};

	var ACTIVE = 'active';
	var allGamesHasInit = false;

	lobby.hide = function hideLobby() {
		$('#casino-lobby').hide();
	};

	lobby.isTopMenuLiveCasinoSelected = isTopMenuLiveCasinoSelected();

	function isTopMenuLiveCasinoSelected() {
		return !!$('#livecasinotab').hasClass('active');
	}

	function loadCasinoLobby($active) {
		closeAllDialogs();
		$('#casino-lobby').show();
		showTab($active);
		autoClickGameProvidersBasedOnHashParameters();
	}

	function closeAllDialogs(){
		if($('#dialog-loginpopuplivecasino').is(':visible')){
			dialog.closeAll();
		}
	}
	function findActiveCasinoTab(page) {
		return $('#casino-top-menu').find('a[href="' + page + '"]');
	}

	function highlightActiveCasinoTab($active) {
		$active.parent().addClass(ACTIVE).siblings().removeClass(ACTIVE);
	}

	function resetBackground() {
		$('.bg-main').removeAttr('style');
	}

	function showTab($active) {
		var $content = $('#casino-lobby').find('.content-wrapper');
		var $searchResults = $('#searchresults');
		$content.find('div[id^=casino-]').hide();
		var tab = $active.data('for');
		resetBackground();
        if (tab === undefined){
            tab = '#casino-start';
        }
		$content.find(tab).show();
		switch (tab) {
			case '#casino-start':
				casinoStart.init();
				break;
			case '#casino-allgames':
				allgames.init();
				allgames.clickLiveCasinoFilterOnLiveCasinoTab();
				break;
			case '#casino-tournaments':
				break;
			case '#casino-jackpots':
				jackpots.init();
				break;
			case '#casino-winners':
				casinoWinners.init();
				break;
			case '#casino-mycasino':
				mycasino.update();
				break;
		}
		/* CO-9882 Close the search frame after closing a game in casino lobby */
		if ($searchResults.css('display') !== 'none') {
			window.casino.search.clear($('#casino-gamesearch'), $searchResults);
		}
	}

	function restoreLastScrollPosition() {
		if (casino.lastLobbyScrollPosition) {
			scrollTo(0, casino.lastLobbyScrollPosition);
		}
		casino.lastLobbyScrollPosition = undefined;
	}

	function autoClickGameProvidersBasedOnHashParameters() {
		var $casinoAllGames = $('#casino-allgames');

		var providers = allgames.getGameProvidersExtractedFromHash();

		$casinoAllGames.find('#filter-providers li').each(function () {
			var $li = $(this);
			var id = $li.attr('id');
			if (($li.hasClass('active') && providers.indexOf(id) < 0) || (!$li.hasClass('active') && providers.indexOf(id) > -1)) {
				$li.click();
			}
		});
	}

	lobby.show = function showLobby() {

		billboard.init();

		if (!allGamesHasInit) {
			allgames.init();
			allGamesHasInit = allGamesHasInit || true;
		}

		var exactHref = location.pathname + location.hash;
		var $active = findActiveCasinoTab(exactHref);
		if ($active.length === 0) {
			var hashWithoutGameProviders = allgames.getHashWithoutGameProviders();
			var page = location.pathname + hashWithoutGameProviders;
			$active = findActiveCasinoTab(page);
		}

		highlightActiveCasinoTab($active);

		loadCasinoLobby($active);
		restoreLastScrollPosition();
		casino.lastSelectedLobbyTab = exactHref;
		activity.moveToLobby();
		tournaments.normalLeaderboardUpdate();

	};

	return lobby;
});

